import { render, staticRenderFns } from "./DrawerWhyChooseUs.vue?vue&type=template&id=ff874aac&scoped=true&"
import script from "./DrawerWhyChooseUs.vue?vue&type=script&lang=js&"
export * from "./DrawerWhyChooseUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff874aac",
  null
  
)

export default component.exports